import React from 'react';
import switchImg1 from '../../assets/images/game-switch.svg';
import switchImg2 from '../../assets/images/game-switch-sec.svg';
import { TableTypes } from '../../enums/tableTypes';

const SwitchTable = ({setMainTableType, mainTableType, isReplay}) =>{
  return (
    <div
      className={`r-mid-game-ver-wrp ${isReplay ? 'isReplay' : ''}`}
      onClick={() => setMainTableType(mainTableType === TableTypes.Rectangle ? TableTypes.Oval : TableTypes.Rectangle)}
    >
      <div className='game-ver-big-cont'>
        <img className='switchImg1' src={switchImg1} alt='' />
        <img className='switchImg2' src={switchImg2} alt='' />
      </div>
    </div>
  );
};
export default SwitchTable
